import { EntityRequest } from "../entity/EntityRequest";
import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestHolidaysGetRes } from "./abst/DtoRequestHolidaysGetRes";

export class DtoRequestHolidaysGetResImple extends DtoRequestHolidaysGetRes {
  public request = new EntityRequest();
  
  public pager = new DtoApiPager();
}
